import { render, staticRenderFns } from "./centreLeft2Chart.vue?vue&type=template&id=60068a4b&scoped=true&"
import script from "./centreLeft2Chart.vue?vue&type=script&lang=js&"
export * from "./centreLeft2Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60068a4b",
  null
  
)

export default component.exports